import { Form } from 'react-bootstrap';

interface FormInputProps {
  label?: string;
  type: string;
  placeholder?: string;
  name: string;
  value: string | number;
  error: string;
  touched: boolean;
  mb: string;
  as: 'input' | 'textarea';
  disabled?: boolean;
  required?: boolean;
  className?: string;
  onChange?: any;
  onKeyDown?: any;
  onClick?: () => void;
}

const FormInput = ({
  label,
  type,
  placeholder,
  name,
  className,
  value,
  disabled,
  onChange,
  touched,
  required = true,
  error,
  mb,
  as,
  onKeyDown,
  onClick,
}: FormInputProps) => {
  return (
    <Form.Group
      className={`mb-${mb} form-input-group ${className}`}
      onClick={onClick}
    >
      {label && (
        <Form.Label>
          {label} {required && <span>*</span>}
        </Form.Label>
      )}
      <Form.Control
        type={type}
        as={as}
        className="form-control shadow-none"
        placeholder={placeholder}
        name={name}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
      {error && touched && (
        <Form.Control.Feedback type="invalid" className="d-block">
          {touched && error}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default FormInput;

FormInput.defaultProps = {
  type: 'text',
  error: '',
  touched: false,
  as: 'input',
  value: '',
  mb: '3',
};
